import { PageId } from '../../components/Sidebar/Sidebar';
import { UploadPage, UploadType } from '../../components/UploadPage/UploadPage';

const CreditReportUploadPage = () => {
  return (
    <UploadPage
      title="Upload Credit Data"
      uploadType={UploadType.CreditReport}
      pageId={PageId.CreditReport}
      showDateRange
    />
  );
};

export default CreditReportUploadPage;
